
import Vue from 'vue'
export default Vue.extend({
  props: {
    type: {
      type: String,
      required: false,
      default: 'primary',
    },
    href: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    tag() {
      if (this.$props.href === '') {
        return 'button'
      } else {
        return 'a'
      }
    },
  },
  methods: {
    clickButton() {
      this.$emit('clickButton')
    },
  },
})
